export default "__VITE_ASSET__rgQL0n1O__"